export const imgs = `[
  {
    "alias": "yatagan-strim",
    "img": "yatagan-strim_main_0.jpeg",
    "type": "main"
  },
  {
    "alias": "yatagan-strim",
    "img": "yatagan-strim_main_1.jpeg",
    "type": "main"
  },
  {
    "alias": "yatagan-strim",
    "img": "yatagan-strim_dimensions.jpg",
    "type": "dimensions"
  },
  {
    "alias": "yatagan-strim",
    "img": "yatagan-strim_manual.jpg",
    "type": "manual"
  },
  {
    "alias": "gidrofiltr-yatagan-hydro",
    "img": "gidrofiltr-yatagan-hydro_main_0.jpeg",
    "type": "main"
  },
  {
    "alias": "gidrofiltr-yatagan-hydro",
    "img": "gidrofiltr-yatagan-hydro_main_1.jpeg",
    "type": "main"
  },
  {
    "alias": "gidrofiltr-yatagan-hydro",
    "img": "gidrofiltr-yatagan-hydro_dimensions.png",
    "type": "dimensions"
  },
  {
    "alias": "gidrofiltr-yatagan-hydro",
    "img": "gidrofiltr-yatagan-hydro_manual.png",
    "type": "manual"
  },
  {
    "alias": "yatagan-safe-fire",
    "img": "yatagan-safe-fire_main_0.jpeg",
    "type": "main"
  },
  {
    "alias": "yatagan-safe-fire",
    "img": "yatagan-safe-fire_main_1.jpeg",
    "type": "main"
  },
  {
    "alias": "yatagan-safe-fire",
    "img": "yatagan-safe-fire_dimensions.png",
    "type": "dimensions"
  },
  {
    "alias": "yatagan-safe-fire",
    "img": "yatagan-safe-fire_manual.png",
    "type": "manual"
  },
  {
    "alias": "smart-ze",
    "img": "smart-ze_main_0.jpeg",
    "type": "main"
  },
  {
    "alias": "smart-ze",
    "img": "smart-ze_main_1.jpeg",
    "type": "main"
  },
  {
    "alias": "dymofiltr-iskrogasitel-yatagan-smoke",
    "img": "dymofiltr-iskrogasitel-yatagan-smoke_main_0.jpeg",
    "type": "main"
  },
  {
    "alias": "dymofiltr-iskrogasitel-yatagan-smoke",
    "img": "dymofiltr-iskrogasitel-yatagan-smoke_main_1.jpeg",
    "type": "main"
  },
  {
    "alias": "dymofiltr-iskrogasitel-yatagan-smoke",
    "img": "dymofiltr-iskrogasitel-yatagan-smoke_dimensions.png",
    "type": "dimensions"
  },
  {
    "alias": "dymofiltr-iskrogasitel-yatagan-smoke",
    "img": "dymofiltr-iskrogasitel-yatagan-smoke_manual.png",
    "type": "manual"
  },
  {
    "alias": "ustanovka-komplexnoy-ochistki-yatagan-complex",
    "img": "ustanovka-komplexnoy-ochistki-yatagan-complex_main_0.jpeg",
    "type": "main"
  },
  {
    "alias": "ustanovka-komplexnoy-ochistki-yatagan-complex",
    "img": "ustanovka-komplexnoy-ochistki-yatagan-complex_dimensions.png",
    "type": "dimensions"
  },
  {
    "alias": "ustanovka-komplexnoy-ochistki-yatagan-complex",
    "img": "ustanovka-komplexnoy-ochistki-yatagan-complex_manual.png",
    "type": "manual"
  },
  {
    "alias": "vozduhoochistitel-ventilyatsionnyy-yatagan-out",
    "img": "vozduhoochistitel-ventilyatsionnyy-yatagan-out_main_0.jpeg",
    "type": "main"
  },
  {
    "alias": "vozduhoochistitel-ventilyatsionnyy-yatagan-out",
    "img": "vozduhoochistitel-ventilyatsionnyy-yatagan-out_main_1.jpeg",
    "type": "main"
  },
  {
    "alias": "vozduhoochistitel-ventilyatsionnyy-yatagan-out",
    "img": "vozduhoochistitel-ventilyatsionnyy-yatagan-out_manual.png",
    "type": "manual"
  },
  {
    "alias": "dymofiltr-yatagan-smokehouse",
    "img": "dymofiltr-yatagan-smokehouse_main_0.jpeg",
    "type": "main"
  },
  {
    "alias": "dymofiltr-yatagan-smokehouse",
    "img": "dymofiltr-yatagan-smokehouse_dimensions.png",
    "type": "dimensions"
  },
  {
    "alias": "dymofiltr-yatagan-smokehouse",
    "img": "dymofiltr-yatagan-smokehouse_manual.png",
    "type": "manual"
  },
  {
    "alias": "vozduhoochistitel-avtonomnyy-yatagan-recycle",
    "img": "vozduhoochistitel-avtonomnyy-yatagan-recycle_main_0.jpeg",
    "type": "main"
  },
  {
    "alias": "vozduhoochistitel-avtonomnyy-yatagan-recycle",
    "img": "vozduhoochistitel-avtonomnyy-yatagan-recycle_manual.png",
    "type": "manual"
  },
  {
    "alias": "dezinfektsionnyi-barer-2",
    "img": "dezinfektsionnyi-barer-2_main_0.png",
    "type": "main"
  },
  {
    "alias": "dezinfektsionnyi-barer-max",
    "img": "dezinfektsionnyi-barer-max_main_0.png",
    "type": "main"
  }
]`;
